export const FETCH_ACCESS_PROFILE_FAILURE = 'FETCH_ACCESS_PROFILE_FAILURE';
export const FETCH_ACCESS_PROFILE_LOADING = 'FETCH_ACCESS_PROFILE_LOADING';
export const FETCH_ACCESS_PROFILE_SUCCESS = 'FETCH_ACCESS_PROFILE_SUCCESS';

export const ADD_ACCESS_PROFILE_SUCCESS = 'ADD_ACCESS_PROFILE_SUCCESS';
export const ADD_ACCESS_PROFILE_FAILURE = 'ADD_ACCESS_PROFILE_FAILURE';
export const ADD_ACCESS_PROFILE_LOADING = 'ADD_ACCESS_PROFILE_LOADING';

export const UPDATE_ACCESS_PROFILE_SUCCESS = 'UPDATE_ACCESS_PROFILE_SUCCESS';
export const UPDATE_ACCESS_PROFILE_FAILURE = 'UPDATE_ACCESS_PROFILE_FAILURE';
export const UPDATE_ACCESS_PROFILE_LOADING = 'UPDATE_ACCESS_PROFILE_LOADING';

export const DELETE_ACCESS_PROFILE_SUCCESS = 'DELETE_ACCESS_PROFILE_SUCCESS';
export const DELETE_ACCESS_PROFILE_FAILURE = 'DELETE_ACCESS_PROFILE_FAILURE';
export const DELETE_ACCESS_PROFILE_LOADING = 'DELETE_ACCESS_PROFILE_LOADING';

// export const FETCH_GROUP_ACCESS_SUCCESS = 'FETCH_GROUP_ACCESS_SUCCESS';
// export const FETCH_GROUP_ACCESS_FAILURE = 'FETCH_GROUP_ACCESS_FAILURE';

export const ADD_GROUP_WITH_PRIORITY_LOADING = 'ADD_GROUP_WITH_PRIORITY_LOADING';
export const ADD_GROUP_WITH_PRIORITY_SUCCESS = 'ADD_GROUP_WITH_PRIORITY_SUCCESS';
export const ADD_GROUP_WITH_PRIORITY_FAILURE = 'ADD_GROUP_WITH_PRIORITY_FAILURE';

export const UPDATE_GROUP_ZONE_PRIORITIES_LOADING = 'UPDATE_GROUP_ZONE_PRIORITIES_LOADING';
export const UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS = 'UPDATE_GROUP_ZONE_PRIORITIES_SUCCESS';
export const UPDATE_GROUP_ZONE_PRIORITIES_FAILURE = 'UPDATE_GROUP_ZONE_PRIORITIES_FAILURE';

export const FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING = 'FETCH_GROUPS_BY_ZONE_PRIORITY_LOADING';
export const FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS = 'FETCH_GROUPS_BY_ZONE_PRIORITY_SUCCESS';
export const FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE = 'FETCH_GROUPS_BY_ZONE_PRIORITY_FAILURE';
export const CLEAR_GROUP_ACCESS = 'CLEAR_GROUP_ACCESS';
export const CLEAR_FILTERED_PRIORITY_ACCESS = 'CLEAR_FILTERED_PRIORITY_ACCESS';


export const FETCH_GROUP_ACCESS_LOADING = 'FETCH_GROUP_ACCESS_LOADING';
export const FETCH_GROUP_ACCESS_SUCCESS = 'FETCH_GROUP_ACCESS_SUCCESS';
export const FETCH_GROUP_ACCESS_FAILURE = 'FETCH_GROUP_ACCESS_FAILURE';